<h2
    mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="comments"
></h2>
<mat-dialog-content>
    <!-- <ng-container *ngIf="!!get"> -->
    <tt-chat [ttOptions]="chatOptions"></tt-chat>
    <!-- <tt-select ttLabel="doccategory_keyno" [(ttModel)]="get.doccategory_keyno" [ttData]="documentCategories" ttDataId="doccategory_keyno" ttDataName="doccategory_name"></tt-select> -->
    <!-- </ng-container> -->
</mat-dialog-content>
<mat-dialog-actions align="end">
    <!-- <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save> -->
</mat-dialog-actions>
